import { render, staticRenderFns } from "./mini-bio.vue?vue&type=template&id=217aee6a&scoped=true"
import script from "./mini-bio.vue?vue&type=script&lang=js"
export * from "./mini-bio.vue?vue&type=script&lang=js"
import style0 from "./mini-bio.vue?vue&type=style&index=0&id=217aee6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217aee6a",
  null
  
)

export default component.exports